export default {
  computed: {
    dictionary() {
      return {
        custom: {
          address: {
            required: () => this.mess.dialog_base_required_error
          },
          author: {
            required: () => this.mess.dialog_base_required_error
          },
          customerPhone: {
            required: () => this.mess.dialog_base_required_error
          },
          customerRepresentative: {
            required: () => this.mess.dialog_base_required_error
          },
          dateOfSale: {
            required: () => this.mess.dialog_base_required_error
          },
          representativePhone: {
            required: () => this.mess.dialog_base_required_error
          },
          specificationNumber: {
            required: () => this.mess.dialog_base_required_error
          },
          requestForm: {
            required: () => this.mess.dialog_base_required_error
          },
          dateOfIncident: {
            required: () => this.mess.dialog_base_required_error
          },
          details: {
            required: () => this.mess.dialog_base_required_error
          },
          dateOfInstallation: {
            required: () => this.mess.dialog_base_required_error
          },
          plannedOperatingTime: {
            required: () => this.mess.dialog_base_required_error
          },
          actualOperatingTime: {
            required: () => this.mess.dialog_base_required_error
          },
          conveyorLength: {
            required: () => this.mess.dialog_base_required_error
          },
          tapeDesignation: {
            required: () => this.mess.dialog_base_required_error
          },
          tapeSpeed: {
            required: () => this.mess.dialog_base_required_error
          },
          efficiency: {
            required: () => this.mess.dialog_base_required_error
          },
          angleOfInclination: {
            required: () => this.mess.dialog_base_required_error
          },
          materialDensity: {
            required: () => this.mess.dialog_base_required_error
          },
          lumpiness: {
            required: () => this.mess.dialog_base_required_error
          },
          dropHeight: {
            required: () => this.mess.dialog_base_required_error
          },
          minAirTemperature: {
            required: () => this.mess.dialog_base_required_error
          },
          materialTemperature: {
            required: () => this.mess.dialog_base_required_error
          },
          angleRollers: {
            required: () => this.mess.dialog_base_required_error
          },
          diameterDriveDum: {
            required: () => this.mess.dialog_base_required_error
          },
          diameterTailDum: {
            required: () => this.mess.dialog_base_required_error
          },
          diameterBypassDum: {
            required: () => this.mess.dialog_base_required_error
          },
          tapeDockingType: {
            required: () => this.mess.dialog_base_required_error
          },
          themes: {
            required: () => this.mess.dialog_base_required_error
          },
          title: {
            required: () => this.mess.dialog_base_required_error
          },
          description: {
            required: () => this.mess.dialog_base_required_error
          },
          process: {
            required: () => this.mess.dialog_base_required_error
          },
          group: {
            required: () => this.mess.dialog_base_required_error
          },
          customer: {
            required: () => this.mess.dialog_base_required_error
          },
          phone: {
            required: () => this.mess.dialog_base_required_error
          },
          request_form: {
            required: () => this.mess.dialog_base_required_error
          },
          service_engineer: {
            required: () => this.mess.dialog_base_required_error
          },
          request_reason: {
            required: () => this.mess.dialog_base_required_error
          },
          incident_description: {
            required: () => this.mess.dialog_base_required_error
          },
          article_element: {
            required: () => this.mess.dialog_base_required_error
          },
          article_original: {
            required: () => this.mess.dialog_base_required_error
          },
          po_n: {
            required: () => this.mess.dialog_base_required_error
          },
          disassembling: {
            required: () => this.mess.dialog_base_required_error
          },
          disassembling_article_element: {
            required: () => this.mess.dialog_base_required_error
          },
          disassembling_article_original: {
            required: () => this.mess.dialog_base_required_error
          },
          disassembling_po_n: {
            required: () => this.mess.dialog_base_required_error
          },
          equipment: {
            required: () => this.mess.dialog_base_required_error
          },
          damage_1: {
            required: () => this.mess.dialog_base_required_error
          },
          damage_2: {
            required: () => this.mess.dialog_base_required_error
          },
          articlesAdditional: {
            required: () => this.mess.dialog_base_required_error
          },
          damage_description: {
            required: () => this.mess.dialog_base_required_error
          },
          customer_requirements: {
            required: () => this.mess.dialog_base_required_error
          },
          custom_unit: {
            required: () => this.mess.dialog_base_required_error
          },
          optime_plan: {
            required: () => this.mess.dialog_base_required_error
          },
          optime_actual: {
            required: () => this.mess.dialog_base_required_error
          },
          optime_average: {
            required: () => this.mess.dialog_base_required_error
          },
          weight: {
            required: () => this.mess.dialog_base_required_error
          },
          material: {
            required: () => this.mess.dialog_base_required_error
          },
          size_1: {
            required: () => this.mess.dialog_base_required_error
          },
          size_2: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_1: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_2: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_3: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_4: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_5: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_6: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_7: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_8: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_9: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_10: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_11: {
            required: () => this.mess.dialog_base_required_error
          },
          shs_param_12: {
            required: () => this.mess.dialog_base_required_error
          },
          bill_num: {
            required: () => this.mess.dialog_base_required_error
          },
          reason_for_close: {
            required: () => this.mess.dialog_base_required_error
          },
          first_name: {
            required: () => this.mess.dialog_base_required_error
          },
          last_name: {
            required: () => this.mess.dialog_base_required_error
          },
          responsible_team: {
            required: () => this.mess.dialog_base_required_error
          },
          priority: {
            required: () => this.mess.dialog_base_required_error
          },
          reason_of_request: {
            required: () => this.mess.dialog_base_required_error
          },
          work_type: {
            required: () => this.mess.dialog_base_required_error
          },
          fio: {
            required: () => this.mess.dialog_base_required_error
          },
          email: {
            required: () => this.mess.dialog_base_required_error
          },
          list_companies: {
            required: () => this.mess.dialog_base_required_error
          },
          company: {
            required: () => this.mess.dialog_base_required_error
          }
        }
      };
    }
  }
};
